import layoutHeaderAside from '@/layouts/HeaderAside'
const meta = { auth: true }
export default {
  path: '/demo',
  name: 'demoTool',
  meta,
  component: layoutHeaderAside,
  children: [
    {
      path: 'demo1',
      name: 'demo1',
      component: () => import('@/pages/demo/demotool/Demo1'),
      meta: {
        ...meta,
        title: 'demo'
      }
    },
    {
      path: 'demo2',
      name: 'demo2',
      component: () => import('@/pages/demo/demotool/Demo2'),
      meta: {
        ...meta,
        title: 'demo'
      }
    },
    {
      path: 'demo3',
      name: 'demo3',
      component: () => import('@/pages/demo/demotool/Demo3'),
      meta: {
        ...meta,
        title: 'exscl'
      }
    },
    {
      path: 'demo4',
      name: 'demo4',
      component: () => import('@/pages/demo/demotool/Demo4'),
      meta: {
        ...meta,
        title: '数值格式化'
      }
    },
    {
      path: 'demo5',
      name: 'demo5',
      component: () => import('@/pages/demo/demotool/Demo5'),
      meta: {
        ...meta,
        title: '电话输入限制'
      }
    }
  ]
}
